import { GENERATE_UPLOAD_LINK_PAYMENT } from "..";
import { apiInstance } from "../config/apiInstance";

export type GenerateUploadLinkPaymentRequest = {
  fileName: string[];
};

export type PaymentDocumentUploadLinkResponse = {
  id: number;
  link: string;
  originalName: string;
};

export const generateUploadLinkPayment = async (
  data: GenerateUploadLinkPaymentRequest,
): Promise<PaymentDocumentUploadLinkResponse[]> => {
  const response = await apiInstance.post<PaymentDocumentUploadLinkResponse[]>(
    GENERATE_UPLOAD_LINK_PAYMENT,
    data,
  );
  return response.data;
};
